<template>
	
  <div class="home">
	 <Bar />
   <div class="home-ct">
<div class="login">
	<div class="login-r1">
	<div class="re-tit">
		<h4>LOGIN</h4>
		
		<p>In order to increase the shopping experience, the online shopping mall platform has been strengthened.</p>
	</div>

	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
	
			
	  <el-form-item label="Email" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>

	  <el-form-item label="Password" prop="password">
	    <el-input v-model="ruleForm.password" show-password></el-input>
	  </el-form-item>
	
	<div class="h-button" @click="submitForm('ruleForm')">SIGN IN</div>
	  </el-form-item>
	</el-form>
	</div>
	<div class="login-r2">
		
		
		<div class="re-tit login-r3">
			<h4>CREATE ACCOUNT</h4>
			
			<p>With more ways to unlock exciting perks, this is your all access pass to exclusive rewards. </p>
				<div class="h-button"><router-link to="register">CREATE ACCOUNT</router-link></div>
		</div>
	</div>
	<div class="clear"></div>
</div>
   </div>
   <Sim />
   <Place />
    </div>
</template>
<script>

import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'

export default {
  components: {

	Bar,Place,Sim
  },
  data() {
    return {
            ruleForm: {
				email:'',
				password:''
			
                  },
                  rules: {
					
					  email: [
					    { required: true, message: 'Please fill in email', trigger: 'blur' },
				],password: [
					    { required: true, message: 'Please fill in password', trigger: 'blur' },
				]
                 
                  }
          };
  },  mounted() {
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailLogin",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
						localStorage.setItem("user", JSON.stringify(data.data));
			
		     this.$alert(data.message, '提示', {
		              confirmButtonText: '确定',
		              callback: action => {
		              this.$router.push({ path: "/" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	float: left;
	padding: 50px;
	border-right: 1px dotted #000000;
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
</style>